import * as React from 'react'
import Container, {ContainerProps} from '@mui/material/Container'
import styled from 'styled-components'
import containerStyles from './container.styles'

interface ApContainerProps extends ContainerProps {
  ap_type:
    | 'app_layout'
    | 'app_content_area_wrapper'
    | 'app_content_area'
    | 'app_header'
    | 'app_footer_wrapper'
    | 'app_footer'
    | 'content_section'
}

const apAtomName = {ap_atom_name: 'containerAtom'}

const ContainerAtom = styled((props: ApContainerProps) => (
  <Container {...apAtomName} {...props} />
))`
  ${containerStyles}
`

export default ContainerAtom
